module.exports = __webpack_public_path__ + "img/move.85173331.svg";